<template>
    <b-modal
        ref="modalDelete"
        lazy
        title-tag="h2"
        title="Delete Cash Reconciliation"
        ok-title="Proceed"
        footer-class="d-flex"
    >
        <p>
            Are you sure you want to delete this cash reconciliation?
        </p>

        <template v-slot:modal-footer="{ close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>

<script type="text/javascript">
import Loader from "@/module/commons/loader";
import BillingCashServices from "@/services/billing/billing-cash";

export default {
    components: {
        Loader
    },
    data() {
        return {
            cashId: null,
            isLoading: false
        };
    },
    methods: {
        open(cash) {
            this.cashId = cash.id;
            this.$refs.modalDelete.show();
        },
        async proceed() {
            try {
                this.isLoading = true;

                let res = await BillingCashServices.deleteCashReconciliation(
                    this.cashId
                );

                if (res.code == 200) {
                    this._message("Cash reconciliation deleted."); // success
                    this.$refs.modalDelete.hide();
                    this.$emit("reload");
                } else {
                    throw new Error(
                        `Error: Cash reconciliation failed to be deleted}`
                    );
                }
            } catch (error) {
                this.isLoading = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
